<template>
    <div class="contacts" style="">
        <nav class="top wsl-flex-center-ng wsl-w-100">
            <div class="container wsl-flex-middle-ng">
                <router-link to="/"><img class="wsl-hide-xs" height="38" src="../assets/img/logo.png"/>
                    <img class="wsl-show-xs" height="38"
                         src="../assets/img/logo-short.png"/></router-link>

                <div class="t18 wsl-m-l-auto wsl-hide-xs">
                    <span class="cb-blue Oswald-DemiBold">8 800 </span>
                    <span class="cb-cyan Oswald-DemiBold">700 01 86</span>
                </div>

                <div class="wsl-hide-xs wsl-h-100">
                    <ul class="wsl-flex-middle-ng wsl-h-100 wsl-p-l-30">
                        <li><a href="//centerbooking.org/registration" target="_blank">Регистрация</a></li>
                        <li class="active">Контакты</li>
                        <li><a href="//centerbooking.org/login" target="_blank">Вход</a></li>
                    </ul>
                </div>
                <div class="wsl-show-xs wsl-h-100 wsl-m-l-auto">
                    <ul class="wsl-flex-middle-ng wsl-h-100 wsl-p-l-30">
                        <li><a href="//centerbooking.org/registration" target="_blank">Регистрация</a></li>
                        <li class="active">Контакты</li>
                        <li><a href="//centerbooking.org/login" target="_blank">Вход</a></li>
                    </ul>
                </div>
            </div>
        </nav>

        <div class="wrapper" style="">
            <div class="wsl-flex-ng" style="flex: 1 0 auto;">
                <div class="cb-bg-blue wsl-p-t-30 sidebar"
                     style="padding-left: 6%;
                            width: 26%;
                            padding-right: 2%;
                            flex-direction: column;">
                    <div class="wsl-p-b-25" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                        <div class="Oswald-Light cb-white t48">Москва</div>
                        <div class="Roboto cb-white t16">ул. Тверская,<br>
                            дом 18, корпус 1, офис 513
                        </div>
                        <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:msk2@centerbooking.ru">msk2@centerbooking.ru</a>
                        <a class="Roboto cb-cyan t16 wsl-m-t-5 block" href="tel:+7 (495) 108-7-333">+7 (495)
                            108-7-333</a>
                        <div class="Roboto cb-white wsl-m-t-10">письмо директору:</div>
                        <a class="Roboto cb-cyan t16 wsl-m-t-5 block" href="mailto:msk@centerbooking.ru">msk@centerbooking.ru</a>
                    </div>

                    <div class="wsl-p-b-25" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                        <div class="Oswald-Light cb-white t48">Нижний Новгород</div>
                        <div class="Roboto cb-white t16">ул. Большая Печерская, <br>
                            дом 26, офис 405
                        </div>
                        <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:nn@centerbooking.ru">nn@centerbooking.ru</a>
                        <a class="Roboto cb-cyan t16 wsl-m-t-5 block" href="tel:+7 (831) 423-02-06">+7 (831)
                            423-02-06</a>
                    </div>

                    <div class="wsl-p-b-25" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                        <div class="Oswald-Light cb-white t48">Новосибирск</div>
                        <div class="Roboto cb-white t16">ул. Каменская, <br>
                            дом 32, офис 702
                        </div>
                        <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:nsk@centerbooking.ru">nsk@centerbooking.ru</a>
                        <a class="Roboto cb-cyan t16 wsl-m-t-5 block" href="tel:+7 (383) 363-13-71">+7 (383)
                            363-13-71</a>
                    </div>

                    <div class="wsl-p-b-25" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                        <div class="Oswald-Light cb-white t48">Казань</div>
                        <div class="Roboto cb-white t16">ул. Пушкина, <br>
                            дом 12, офис 303/2
                        </div>
                        <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:kzn@centerbooking.ru">kzn@centerbooking.ru</a>
                        <a class="Roboto cb-cyan t16 wsl-m-t-5 block" href="tel:+7 (843) 206-07-78">+7 (843) 206-07-78</a>
                    </div>

                    <div class="wsl-p-b-25" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                        <div class="Oswald-Light cb-white t48">Екатеринбург</div>
                        <div class="Roboto cb-white t16">ул. Куйбышева, <br>
                            дом 80 корпус 1 офис 2
                        </div>
                        <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:ekb@centerbooking.ru">ekb@centerbooking.ru</a>
<!--                        <a class="Roboto cb-cyan t16 wsl-m-t-5 block" href="tel:+7 (843) 206-07-78">+7 (843) 206-07-78</a>-->
                    </div>

                    <div style="flex: 1 0 auto;"></div>

                    <a class="wsl-flex-middle-ng" href="https://vk.com/centerbooking" target="_blank"
                         style="height: 100px; border-top: 1px solid rgba(255, 255, 255, 0.2);">
                        <img src="../assets/img/vk.png" alt="">
                        <div class="wsl-m-l-15">
                            <div class="Roboto cb-white">Группа Вконтакте</div>
                            <div class="Roboto cb-cyan wsl-bold wsl-m-t-4">CenterBooking.ru</div>
                        </div>
                    </a>
                </div>
                <div class="wsl-col wsl-flex-column-spaceBetween-ng">
                    <div class="wsl-text-center wsl-p-t-30 wsl-p-b-20">
                        <div class="t48 wsl-hide-xs">
                            <span class="Oswald-Light cb-cyan">Офис в </span>
                            <span class="Oswald-Light cb-blue">Санкт-Петербурге</span>
                        </div>
                        <div class="t36 wsl-show-xs">
                            <span class="Oswald-Light cb-cyan">Офис в </span>
                            <span class="Oswald-Light cb-blue">Санкт-Петербурге</span>
                        </div>
                        <span class="Roboto cb-grey t16">191025, Санкт-Петербург, <br class="wsl-show-xs"> Невский проспект, дом 67</span><br>
                        <a class="Roboto cb-cyan t16 wsl-m-t-5 block" href="tel:+7 (812) 601-06-09">+7 (812)
                            601-06-09</a>
                        <a class="Roboto cb-cyan t16 wsl-m-t-5 block" href="mailto:spb@centerbooking.ru">spb@centerbooking.ru</a>
                        <div class="t36 wsl-hide-xs">
                            <span class="Oswald-Light cb-cyan">8 800 </span>
                            <span class="Oswald-Light cb-blue">7000 186</span>
                        </div>
                        <div class="t30 wsl-show-xs">
                            <span class="Oswald-Light cb-cyan">8 800 </span>
                            <span class="Oswald-Light cb-blue">7000 186</span>
                        </div>
                        <span class="Roboto cb-grey">(бесплатный многоканальный)</span>
                    </div>

                    <div class="wsl-col map wsl-relative">
                        <yandex-map
                                :coords="[59.931634, 30.353876]"
                                zoom="16"
                                style="width: 100%; height: 100%;"
                                :cluster-options="{
                                  1: {clusterDisableClickZoom: true}
                                }"
                                :behaviors="['default']"
                                :controls="['fullscreenControl', 'zoomControl', 'geolocationControl', 'trafficControl']"
                                map-type="map"
                                @map-was-initialized="initHandler">

                            <ymap-marker
                                    marker-id="1"
                                    marker-type="placemark"
                                    :coords="[55.766147, 37.604241]"
                                    hint-content="Москва, ул. Тверская, д. 18 к1"
                                    :balloon="{header: 'ул. Тверская', body: 'дом 18, корпус 1, офис 637', footer: '+7 (495) 108-7-333'}"
                                    :icon="{color: 'blue', glyph: 'info'}"
                                    cluster-name="1"></ymap-marker>

                            <ymap-marker
                                    marker-id="2"
                                    marker-type="placemark"
                                    :coords="[56.325085, 44.023279]"
                                    hint-content="Нижний Новгород, ул. Большая Печерская, д. 26"
                                    :balloon="{header: 'ул. Большая Печерская', body: 'дом 26, офис 405', footer: '+7 (831) 423-02-06'}"
                                    :icon="{color: 'blue', glyph: 'info'}"
                                    cluster-name="1"></ymap-marker>

                            <ymap-marker
                                    marker-id="3"
                                    marker-type="placemark"
                                    :coords="[55.030111, 82.929494]"
                                    hint-content="Новосибирск, ул. Каменская, д. 32"
                                    :balloon="{header: 'ул. Каменская', body: 'дом 32, офис 702', footer: '+7 (383) 363-13-71'}"
                                    :icon="{color: 'blue', glyph: 'info'}"
                                    cluster-name="1"></ymap-marker>

                            <ymap-marker
                                    marker-id="4"
                                    marker-type="placemark"
                                    :coords="[55.789036, 49.124838]"
                                    hint-content="Казань, ул. Пушкина, д. 12"
                                    :balloon="{header: 'Пушкина', body: 'дом 12', footer: '+7 (843) 206-07-78'}"
                                    :icon="{color: 'blue', glyph: 'info'}"
                                    cluster-name="1"></ymap-marker>

                            <ymap-marker
                                    marker-id="5"
                                    marker-type="placemark"
                                    :coords="[56.830280, 60.640378]"
                                    hint-content="Екатеринбург, ул. Куйбышева, д. 80 корпус 1"
                                    :balloon="{header: 'Куйбышева', body: 'д. 80 корпус 1', footer: ''}"
                                    :icon="{color: 'blue', glyph: 'info'}"
                                    cluster-name="1"></ymap-marker>

                            <ymap-marker
                                    marker-id="6"
                                    marker-type="placemark"
                                    :coords="[59.931634, 30.353876]"
                                    hint-content="Санкт-Петербург, Невский проспект, д. 67"
                                    :balloon="{header: 'Невский проспект', body: 'дом 67', footer: '+7 (812) 601-06-09'}"
                                    :icon="{color: 'blue', glyph: 'info'}"
                                    cluster-name="1"></ymap-marker>

                        </yandex-map>
                    </div>
                    <div class="wsl-flex-spaceBetween-ng wsl-hide-sm wsl-hide-xs" style="height: 100px;">
                        <div class="wsl-col-nogrow wsl-p-x-25 wsl-p-y-10" style="">
                            <div>
                                <div class="Oswald-Light cb-cyan t18">Бухгалтерия и финансовый отдел</div>
                                <span class="Roboto cb-grey">buh@centerbooking.ru</span><br>
                                <span class="Roboto cb-grey">+7 (812) 601-06-09</span><br>
                                <span class="Roboto cb-grey t12">Пн - Пт с 10:00 до 19:00</span>
                            </div>
                        </div>

                        <div style="height: 80px; margin: 10px 0; border-right: 1px solid #e5e5e5;"></div>

                        <div class="wsl-col-nogrow wsl-p-x-25 wsl-p-y-10" style="">
                            <div>
                                <div class="Oswald-Light cb-cyan t18">Отдел бронирования и подтверждения</div>
                                <span class="Roboto cb-grey">spb6@centerbooking.ru</span><br>
                                <span class="Roboto cb-grey">+7 (812) 601-06-09</span><br>
                                <span class="Roboto cb-grey t12">Пн - Пт с 10:00 до 20:00, Сб с 12:00 до 17:00</span>
                            </div>
                        </div>

                        <div style="height: 80px; margin: 10px 0; border-right: 1px solid #e5e5e5;"></div>

                        <div class="wsl-col-nogrow wsl-p-x-25 wsl-p-y-10" style="">
                            <div>
                                <div class="Oswald-Light cb-cyan t18">Отдел визирования и выгрузки документов</div>
                                <span class="Roboto cb-grey">visa@centerbooking.ru</span><br>
                                <span class="Roboto cb-grey">+7 (812) 601-06-09</span><br>
                                <span class="Roboto cb-grey t12">Пн - Пт с 11:00 до 19:00, Сб с 12:00 до 17:00</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="wsl-flex-3_from-sm-1-ng cb-bg-blue bottombar wsl-p-x-15 wsl-p-y-10">
                <div class="wsl-col wsl-p-b-15 wsl-p-x-15" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                    <div class="Oswald-Light cb-white t36">Москва</div>
                    <div class="Roboto cb-white t16">ул. Тверская,<br>
                        дом 18, корпус 1, офис 513
                    </div>
                    <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:msk2@centerbooking.ru">msk2@centerbooking.ru</a>
                    <div class="Roboto cb-cyan t16 wsl-m-t-20">+7 (495) 108-7-333</div>
                    <div class="Roboto cb-white wsl-m-t-10">письмо директору:</div>
                    <a class="Roboto cb-cyan t16 wsl-m-t-5 block" href="mailto:msk@centerbooking.ru">msk@centerbooking.ru</a>
                </div>

                <div class="wsl-col wsl-p-b-15 wsl-p-x-15" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                    <div class="Oswald-Light cb-white t36">Нижний Новгород</div>
                    <div class="Roboto cb-white t16">ул. Большая Печерская, <br>
                        дом 26, офис 405
                    </div>
                    <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:nn@centerbooking.ru">nn@centerbooking.ru</a>
                    <div class="Roboto cb-cyan t16 wsl-m-t-20">+7 (831) 423-02-06</div>
                </div>

                <div class="wsl-col wsl-p-b-15 wsl-p-x-15" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                    <div class="Oswald-Light cb-white t36">Новосибирск</div>
                    <div class="Roboto cb-white t16">ул. Каменская, <br>
                        дом 32, офис 702
                    </div>
                    <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:nsk@centerbooking.ru">nsk@centerbooking.ru</a>
                    <div class="Roboto cb-cyan t16 wsl-m-t-20">+7 (383) 363-13-71</div>
                </div>

                <div class="wsl-col wsl-p-b-15 wsl-p-x-15" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                    <div class="Oswald-Light cb-white t36">Казань</div>
                    <div class="Roboto cb-white t16">ул. Пушкина, <br>
                        дом 12, офис 303/2
                    </div>
                    <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:kzn@centerbooking.ru">kzn@centerbooking.ru</a>
                    <div class="Roboto cb-cyan t16 wsl-m-t-20">+7 (843) 206-07-78</div>
                </div>

                <div class="wsl-col wsl-p-b-15 wsl-p-x-15" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
                    <div class="Oswald-Light cb-white t36">Екатеринбург</div>
                    <div class="Roboto cb-white t16">ул. Куйбышева, <br>
                        дом 80 корпус 1 офис 2
                    </div>
                    <a class="Roboto cb-cyan t16 wsl-m-t-20 block" href="mailto:ekb@centerbooking.ru">ekb@centerbooking.ru</a>
<!--                    <div class="Roboto cb-cyan t16 wsl-m-t-20">+7 (843) 206-07-78</div>-->
                </div>

                <a class="wsl-flex-middle-ng" style="height: 80px;" href="https://vk.com/centerbooking" target="_blank">
                    <img src="../assets/img/vk.png" alt="">
                    <div class="wsl-m-l-15">
                        <div class="Roboto cb-white">Группа Вконтакте</div>
                        <div class="Roboto cb-cyan wsl-bold wsl-m-t-4">CenterBooking.ru</div>
                    </div>
                </a>
            </div>
        </div>

        <footer>
            <div class="container wsl-flex-middle-ng p-l-side wsl-p-r-20">
                <div class="t24">
                    <span class="cb-blue Oswald-Medium">8 800 </span>
                    <span class="cb-white Oswald-Medium">700 01 86</span>
                </div>

                <div class="t16 wsl-m-l-40 wsl-hide-xs">
                    <span class="cb-white Oswald-Light">ООО “ЦентрБукинг.Ру”</span>
                </div>
                <div class="t16 wsl-m-l-auto wsl-show-xs">
                    <span class="cb-white Oswald-Light">ООО “ЦентрБукинг.Ру”</span>
                </div>

                <div class="wsl-m-l-auto wsl-hide-xs">
                    <a class="wsl-white wsl-hover Roboto" style="border-bottom: 1px dashed; ">Политика
                        конфиденциальности</a>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import map from '@/assets/img/map.jpg'
import { yandexMap, ymapMarker } from 'vue-yandex-maps'

export default {
  name: 'Contacts',
  components: { yandexMap, ymapMarker },
  data () {
    return {
      map: map,
      placemarks: [
        {
          coords: [54.8, 39.8],
          properties: {}, // define properties here
          options: {}, // define options here
          clusterName: '1',
          balloonTemplate: '<div>"Your custom template"</div>',
          callbacks: {
            click: function () {
            }
          }
        }
      ]
    }
  },
  methods: {
    initHandler (e) {
      console.log('init map', e)
    }
  }
}
</script>
